module.exports = {
          srcSet: __webpack_public_path__ + "8e67b8b739353b5c225846f1627992ea-444.webp"+" 444w",
          images:[ {path: __webpack_public_path__ + "8e67b8b739353b5c225846f1627992ea-444.webp",width: 444,height: 168}],
          src: __webpack_public_path__ + "8e67b8b739353b5c225846f1627992ea-444.webp",
          toString:function(){return __webpack_public_path__ + "8e67b8b739353b5c225846f1627992ea-444.webp"},
          
          width: 444,
          height: 168
        }